import { QueryStringValuesAccessor } from "./QueryStringValuesAccessor";
import { WindowLocationWrapper } from "../window_wrapping/WindowLocationWrapper";

export class DefaultQueryStringValuesAccessor
	implements QueryStringValuesAccessor
{
	constructor(private readonly windowLocation: WindowLocationWrapper) {
		// do nothing
	}

	getValueByKey(key: string): string | undefined {
		const queryStringValue = new URLSearchParams(
			this.windowLocation.search
		).get(key);
		return queryStringValue === null ? undefined : queryStringValue;
	}
}
